module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/contractor-doc-type/doc-type-form/doc-type-form.component.css
// module id = ./src/app/technical/contractor-doc-type/doc-type-form/doc-type-form.component.css
// module chunks = main